module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('span', {
    staticClass: "th11"
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_c('img', {
    attrs: {
      "alt": "img1.jpg",
      "height": "48",
      "src": "Images/img1.jpg",
      "width": "48"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Published by")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t2"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" "), _c('span', {
    staticClass: "t1"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "t2"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("5032 Capital Circle SW, Suite 2, PMB# 279, Tallahassee, FL 32305-7886  USA")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Dies ist eine erfundene Geschichte. Namen, Figuren, Plätze, und Vorfälle entstammen entweder der Fantasie des Autors oder werden fiktiv verwendet. Ähnlichkeiten mit lebenden oder verstorbenen Personen, Firmen, Ereignissen oder Schauplätzen sind vollkommen zufällig.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Horizonte")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Urheberrecht der deutschen Ausgabe © 2015 Dreamspinner Press.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Originaltitel: Horizons")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Urheberrecht © 2013")]), _vm._v(" "), _c('span', {
    staticClass: "t1"
  }, [_vm._v("Mickie B. Ashling")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Übersetzt von Jutta Grobleben.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Umschlagillustration")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("© 2013 Reese Dante.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("http://www.reesedante.com")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Die Illustrationen auf dem Einband bzw. Titelseite werden nur für darstellerische Zwecke genutzt. Jede abgebildete Person ist ein Model.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Alle Rechte vorbehalten. Dieses Buch ist ausschließlich für den Käufer lizensiert. Eine Vervielfältigung oder Weitergabe in jeder Form ist illegal und stellt eine Verletzung des Internationalen Copyright-Rechtes dar. Somit werden diese Tatbestände strafrechtlich verfolgt und bei Verurteilung mit Geld- und oder Haftstrafen geahndet. Dieses eBook kann nicht legal verliehen oder an andere weitergegeben werden. Kein Teil dieses Werkes darf ohne die ausdrückliche Genehmigung des Verlages weder Dritten zugänglich gemacht noch reproduziert werden. Bezüglich einer entsprechenden Genehmigung und aller anderen Fragen wenden Sie sich an den Verlag Dreamspinner Press, 5032 Capital Cir. SW, Ste 2 PMB# 279, Tallahassee, FL 32305-7886, USA oder unter http://www.dreamspinnerpress.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Deutsche eBook Ausgabe. 978-1-62380-770-2")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Deutsche Erstausgabe. August 2015")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Zweit Erstausgabe. Juli 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Originalausgabe veröffentlicht von")]), _vm._v(" "), _c('span', {
    staticClass: "t1"
  }, [_vm._v("Dreamspinner Press, April 2009.")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Gedruckt in den Vereinigten Staaten von Amerika.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e40974","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003.vue
// module id = 60
// module chunks = 0